import React from "react";
import { styled } from "@material-ui/core/styles";
import MuiIconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiTypography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

import Modal from "components/styled/modal/Modal";
import pxToRem from "libs/pxToRem";
import DocumentViewer from "components/business/documentViewer/DocumentViewer";
import { useSolicitudConsumoDocuments } from "components/hooks/useSolicitudConsumoDocuments";

interface ISolicitudFirmadaModal {
  solicitudId: number | undefined;
  open: boolean;
  onClose: () => void;
}

const SolicitudFirmadaModal = ({
  solicitudId,
  open,
  onClose,
}: ISolicitudFirmadaModal) => {
  const { data: pdfUrl, isLoading } = useSolicitudConsumoDocuments(
    solicitudId,
    "solicitud",
    open && !!solicitudId,
  );

  const hasPdfUrl = Boolean(pdfUrl);

  return (
    <Modal
      onClose={onClose}
      opened={open}
      modalHeader={
        <Box>
          <IconButton aria-label="close" onClick={onClose}>
            <CloseIcon />
          </IconButton>

          <ModalTitle>
            <Title>Solicitud firmada - Solicitud {solicitudId}</Title>
          </ModalTitle>
        </Box>
      }
      maxWidth="xl"
    >
      <DocumentViewer
        documentUrl={pdfUrl || ""}
        loading={isLoading}
        hasDocument={hasPdfUrl}
        emptyTitle="Solicitud no disponible"
        emptyMessage="No hay una solicitud firmada asociada a esta solicitud."
      />
    </Modal>
  );
};

export default SolicitudFirmadaModal;

const Title = styled(MuiTypography)({
  fontSize: pxToRem(20),
  fontWeight: "bold",
  lineHeight: 1.89,
  letterSpacing: 0.45,
  textAlign: "center",
});

const IconButton = styled(MuiIconButton)(({ theme }) => ({
  position: "absolute",
  right: theme.spacing(1),
  top: theme.spacing(1),
  color: theme.palette.grey[500],
}));

const ModalTitle = styled(MuiDialogTitle)({
  "&.MuiDialogTitle-root": {
    marginTop: pxToRem(15),
  },
});
